import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-table-icon',
    templateUrl: './table-icon.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TableIconComponent {}
